<template>
  <div>
    <base-loading :visible="isLoading" />
    <edit-grace-period v-model="editPeriod" :title="$t('grace_period') | capitalize" :item="selectedItem"
      @save="updateGracePeriod" />
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-full md:col-span-2 md:col-start-11  xs:col-start-1">

        <search-input v-model="search" @search="onSearch" @clear="onSearch" />
      </div>
      <div class="col-span-full col-start-1">
        <clients-table :items="items" @loadMore="loadMore" @sortChanged="onSortChanged" @edit="onEdit"
          @details="onDetails" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useClients } from '../../composables/useClients.js'
import { useNotifier } from '@/composables/useNotifier.js'
import { useNavigator } from '@/composables/useNavigator.js'
import ClientsTable from './components/ClientsTable.vue'
import BaseLoading from '@/views/app/components/BaseLoading.vue'
import SearchInput from '@/views/app/components/SearchInput.vue'
import EditGracePeriod from './components/EditGracePeriod.vue'

const { notify } = useNotifier()
const { goTo } = useNavigator()

const search = ref('')
const clients = useClients()
const selectedItem = ref({})
const editPeriod = ref(false)

const sort = ref({})
const items = computed(() => clients.state.items)
const currentPage = computed(() => clients.state.currentPage)
const lastPage = computed(() => clients.state.lastPage)
const isLoading = computed(() => clients.state.loading)

const loadData = async (params = {}) => {
  const payload = {
    page: clients.state.currentPage || 1,
    search: search.value,
    column: sort.value.column,
    order: sort.value.order,
    ...params
  }
  const result = await clients.getClients(payload)
  if (!result.success) notify({ title: 'error', text: 'message_error', color: 'danger' })
}

const loadMore = async () => {
  if (currentPage.value >= lastPage.value) return
  const newPage = clients.state.currentPage + 1
  await loadData({ page: newPage })
}

const onSearch = async () => {
  await loadData({ page: 1, search: search.value })
}

const onSortChanged = async (sortData) => {
  sort.value.column = sortData.key
  sort.value.order = sortData.order
  await loadData({ column: sort.value.column, order: sort.value.order , page:1})
}

const onEdit = (row) => {
  editPeriod.value = true
  selectedItem.value = { ...row }
}

const updateGracePeriod = async (item) => {
  const payload = { client_id: item.client_id, days: item.gracePeriod }
  const result = await clients.updateGracePeriod(payload)
  if (!result.success) {
    notify({ title: 'attention', text: 'message_error', color: 'warning' })
    return
  }
  editPeriod.value = false
  const clientIndex = clients.state.items.findIndex(c => c.ClientId === item.client_id)
  if (clientIndex !== -1) {
    clients.state.items[clientIndex].days = item.time
    clients.state.items[clientIndex].gracePeriod = item.gracePeriod
  }
  notify({ title: 'success', text: 'message_update', color: 'success' })

}

const onDetails = (row) => {
  goTo({ name: 'warehouse-client-price-detail', params: { client: row.ClientId } })
}

onMounted(() => loadData())

</script>
